import React, { useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

// Landing page for the SSO redirect: reads ?token & ?user, logs in, forwards.
export const SsoCallback: React.FC = () => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const params = new URLSearchParams(window.location.search);
    const error = params.get('sso_error');
    const token = params.get('token');
    const userRaw = params.get('user');

    if (error) {
      navigate(`/login?sso_error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }
    if (token && userRaw) {
      try {
        const user = JSON.parse(userRaw);
        auth.login(user, token);
        navigate('/dashboard', { replace: true });
        return;
      } catch {
        /* fall through */
      }
    }
    navigate('/login?sso_error=Anmeldung%20fehlgeschlagen', { replace: true });
  }, [auth, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-status">Anmeldung wird abgeschlossen …</div>
    </div>
  );
};
